import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';
/**
 * "Someone granted me a card or a card back". Subject is the recipient
 * themselves (see ItemGrantedBlueprint's docblock for why) — the content
 * text is picked from the notification's data.itemType instead, which is
 * 'card' or 'cardBack'.
 */
export default class ItemGrantedNotification extends Notification {
  icon() {
    return 'fas fa-gift';
  }
  href() {
    const user = app.session.user;
    // Links to the recipient's own Arena tab — where both granted cards and
    // card backs actually show up (deck builder / card-backs section) —
    // rather than the plain profile page.
    return user ? app.route('user.arena', {
      username: user.username()
    }) : '#';
  }
  content() {
    const content = this.attrs.notification.content() || {};
    const itemName = content.itemName ?? '';
    return content.itemType === 'cardBack' ? app.translator.trans('forumaker-arena.forum.notifications.card_back_granted_text', {
      name: itemName
    }) : app.translator.trans('forumaker-arena.forum.notifications.card_granted_text', {
      name: itemName
    });
  }
  excerpt() {
    return null;
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ItemGrantedNotification', ItemGrantedNotification);